import {useEffect, useState} from 'react'
import {getsaleMedicalRecordsByClientId} from '../../sales/core/_request'
import {ListSalesHistorySchedules} from '../../sales/components/ListSalesHistorySchedules'
import Swal from 'sweetalert2'

interface IListSalesHistoryMedicalRecord {
  clientID: number
}

const ListSalesHistoryMedicalRecord = ({clientID}: IListSalesHistoryMedicalRecord) => {
  const [dataSale, setDataSale] = useState()
  useEffect(() => {
    const init = async () => {
      try {
        const salesHistorySchedules = await getsaleMedicalRecordsByClientId(clientID)
        setDataSale(salesHistorySchedules)
      } catch (error: any) {
        await Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error?.response?.data?.message,
          timer: 2000,
        })
      }
    }
    init()
  }, [])

  return <ListSalesHistorySchedules salesHistorySchedules={dataSale} />
}

export {ListSalesHistoryMedicalRecord}
